const apiConfig = {
	// web.mims.com.cn
	ApiBaseUrl: "//web.mims.com.cn/",
	/*ApiBaseUrl : "//127.0.0.1:8000/",*/
	preApiBaseUrl: "//service.mims.com.cn/",
	Apitimeout: 15000
};

export default apiConfig;
